<!--
 * @Author: mzw
 * @Date: 2025-04-24 16:05:37
 * @LastEditTime: 2025-05-09 16:48:48
 * @LastEditors: mzw
 * @Description: 侧边-历史会话
-->
<template>
  <div class="aside-box">
    <el-aside class="cf">
      <!-- 物料助手-模式切换 -->
      <div
        class="mode-selector"
      >
        <el-select
          v-model="modeType"
          placeholder="请选择模式"
          style="width: 218px"
          @change="selectMode"
        >
          <el-option
            v-for="(item,index) in modeOpt"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="chat-list flex-1">
        <div
          v-for="(chat_timeGroup,index) in chatList_timeGroup"
          :key="index"
        >
          <div class="chat-time">{{chat_timeGroup.groupName}}</div>
          <div class="content">
            <el-row v-for="chat in chat_timeGroup.itemList" :key="chat.sessionId">
              <div :class="chat.sessionId === activeChat.sessionId?'chat-list-item active':'chat-list-item'"
                   class="rf ac jsb"
                   @click="changeChat(chat)">
                <div class="left rf ac flex-1">
                  <!-- <el-icon class="avatar-icon">
                    <component :is="iconTypeList[chat.iconType]" />
                  </el-icon> -->
                  <span class="chat-title-input" v-if="chat.edit">
                    <el-input
                      v-model="tmpChatTitle"
                      size="mini"
                      @keydown.stop="titleKeydown($event, chat)"
                      @click.stop maxlength="20"
                      placeholder="请输入会话标题"/>
                  </span>
                  <span v-else class="chat-title flex-1">
                    {{ chat.sessionName }}
                  </span>
                </div>
                <div class="btns-box">
                  <span
                    class="btn btn-check rf ac jsb"
                    v-if="chat.edit || chat.removing"
                  >
                    <i class="el-icon el-icon-check"
                      @click.stop="confirm($event, chat)"
                    ></i>
                    <i class="el-icon el-icon-close"
                      @click.stop="cancel($event, chat)"
                    ></i>
                  </span>
                  <span class="btn rf ac jsb" v-else>
                    <i class="el-icon el-icon-edit-outline"
                      @click.stop="editChatTitle($event, chat)"
                    ></i>
                    <i class="el-icon el-icon-delete"
                      @click.stop="removeChat($event, chat)"
                    ></i>
                  </span>
                </div>
              </div>
            </el-row>
          </div>
        </div>
      </div>
      <div class="title-box cf ac">
        <div
          class="btn-box btn-box-empty pointer"
          @click="openAPP"
        >
          <img src="~@/assets/img/AI/phone_icon.png" alt="phone" />
          下载APP
        </div>
        <div
          class="btn-box btn-box-solid pointer"
          @click="newChat()"
        >
          开启新对话
        </div>
      </div>
    </el-aside>
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus.js';
import {
  USER_AUTH_COMPANY_MODAL,
} from "@/components/authCompany/helper";

export default {
  name: 'ChatAside',
  data() {
    return {
      // 历史会话列表相关
      chatList_timeGroup: [], // 会话列表（时间线分组）
      activeChat: null,
      // 编辑会话标题
      curOpt: '',
      tmpChatTitle: '',
      creatingNewChat: false, //正在创建新会话

      // 物料助手模式切换
      modeOpt: [
        { label: '对话模式', value: 1 },
        { label: '批任务模式', value: 2 },
      ],
      modeType: 1,
      defaultCompanyId: '',
      appImg: require('@/assets/img/appDownload.png')
    }
  },
  created() {
    this.defaultCompanyId = localStorage.getItem('defaultCompanyId') || ''
  },
  mounted() {
    this.getSessionList(true);

    EventBus.$on('sideSessionModify', val => {
      const {sessionId, sessionName, iconType} = val
      this.doSessionModify(sessionId,sessionName,iconType).then(()=>{
        //操作成功后执行
        this.getSessionList();
      })
    })
  },
  beforeDestroy() {
    EventBus.$off('sideSessionModify')
  },
  methods: {
    //获取会话列表（分页）
    getSessionList(isLoadThisChat=false){
      this.$http
        .post(`/help/ai/user/session/groupList`, {
          iconType: 4 //限制物料助手类型
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          const resDataList = res.data || []
          if (resDataList.length>0) {
            this.chatList_timeGroup = resDataList;

            if(isLoadThisChat){
              //加载当前会话框内容
              const localChatId = localStorage.getItem("sessionId")
              const localChat = localChatId ? this.getChatById(localChatId) : null
              const chat = localChatId && localChat ? localChat : this.chatList_timeGroup[0].itemList[0]
              this.loadChat(chat)
            }
          }else{
            this.chatList_timeGroup =[]
          }
        })
    },
    // 新建会话
    async newChat(sessionName,iconType) {
      this.creatingNewChat = true
      if(this.$route.path!=='/chatHome'){
        this.$router.push({
          path: '/chatHome'
        })
      }

      const params = {
        sessionName: sessionName || '新会话',
        iconType: iconType || 4,
        sourceType: 2 //来源类型 1:AI数字平台 2：官网平台 3：H5移动端
      }
      this.$http
        .post(`/help/ai/user/session/create`, params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.getSessionList()
          // 切换到该新会话
          this.changeChat(res.data)
        })
        .finally(()=>{
          this.creatingNewChat = false
        });
    },
    // 切换会话
    changeChat(chat){
      if(this.$route.path!=='/chatHome'){
        this.$router.push({
          path: '/chatHome'
        })
      }

      // 清除上一条编辑态
      if(this.activeChat.edit===true && this.activeChat.sessionId !==chat.sessionId) this.activeChat.edit=false

      localStorage.setItem("sessionId", chat.sessionId)
      this.loadChat(chat)
    },
    loadChat(chat) {
      this.activeChat = chat
      EventBus.$emit("loadChat", chat);
    },
    // 编辑会话标题
    editChatTitle(event, chat) {
      event.stopPropagation();
      // chat.edit = true;
      this.$set(chat,'edit',true)
      this.curOpt = 'edit';
      this.tmpChatTitle = chat.sessionName;
    },
    titleKeydown(e, chat) {
      if (e.keyCode === 13) {
        e.stopPropagation();
        this.confirm(e, chat)
      }
    },
    // 确认修改
    confirm(event, chat){
      event.stopPropagation();
      if (this.curOpt === 'edit') {
        if (this.tmpChatTitle === '') {
          return this.$message.error("请输入会话标题！");
        }
        if (!chat.sessionId) {
          return this.$message.error("对话 ID 为空，请刷新页面再试！");
        }
        this.doSessionModify(chat.sessionId, this.tmpChatTitle, null).then(()=>{
          //操作成功后执行
          chat.sessionName = this.tmpChatTitle;
          chat.edit = false;
        })
      }
    },
    async doSessionModify(sessionId,sessionName,iconType){
      let params = {
        sourceType: 2 //来源类型 1:AI数字平台 2：官网平台 3：H5移动端
      }
      if(sessionId) params['sessionId'] = sessionId
      if(sessionName) params['sessionName'] = sessionName
      // iconType有值（0或1或2）↓
      if(!isNaN(parseFloat(iconType))) params['iconType'] = iconType
      this.$http
        .post(`/help/ai/user/session/modify`, params)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          console.log('操作成功')
        }).catch(e => {
          this.$message.error("操作失败：" + e.message);
        })
    },
    //取消修改
    cancel(event, chat) {
      event.stopPropagation();
      chat.edit = false;
    },
    // 删除会话
    async removeChat(event, chat){
      event.stopPropagation();
      this.$confirm(
          '确认删除该会话吗?<br/>此操作不可以撤销！',
          '操作提示：',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            showClose: true,
            closeOnClickModal: false,
            center: true,
          }
      ).then(() => {
        const params = {
          sessionId: chat.sessionId,
          sourceType: 2 //来源类型 1:AI数字平台 2：官网平台 3：H5移动端
        }
        this.$http
          .post(`/help/ai/user/session/remove`, params)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            if(chat.sessionId === localStorage.getItem("sessionId")){
              localStorage.removeItem("sessionId")
            }
            this.$message.success("删除成功！");
            this.getSessionList(true);
          })
          .catch(e => {
            this.$message.error("操作失败：" + e.message);
          })
      }).catch(() => {
      })
    },
    getChatById(sessionId) {
      if (!sessionId) return null
      let returnItem = null
      this.chatList_timeGroup.forEach(chatItem => {
        const chatItemList = chatItem.itemList
        for (let index in chatItemList) {
          if (chatItemList[index].sessionId === sessionId) {
            returnItem = chatItemList[index]
          }
        }
      })
      return returnItem
    },
    selectMode(val) {
      if(val==2) {
        if(!this.defaultCompanyId){
          this.bus.$emit(USER_AUTH_COMPANY_MODAL,'该功能模块限企业用户专享，请先认证企业：');
          this.modeType = 1;
          return
        }
        // 跳转到物料助手-批任务模式
        this.$router.push({
          path: '/materialAssistantBatch'
        })
      }
    },
    openAPP() {
      this.$alert(
        `<div style="text-align:center;"><img src="${this.appImg}" style="width:100px;" /></div>`,
        '扫码下载APP',
        {
          dangerouslyUseHTMLString: true
        }
      ).catch(() => { })
    }
  }
}
</script>

<style scoped lang="scss">
$sideBgColor: rgba(255, 255, 255, 0.6);
.aside-box{
}
.el-aside {
  background-color: $sideBgColor;
  height: 100%;
  width: 262px !important;
  padding: 20px;
}

.mode-selector {
  ::v-deep .el-select {
    border-radius: 8px;
    // 选择框及图标样式
    .el-input__inner,
    .el-icon {
      font-size: 16px !important;
      color: #333 !important;
    }
    .el-input__inner{
      border: none;
    }
  }
  &.small-state {
    left: 5px;
    ::v-deep .el-select {
      .el-input__inner,
      .el-icon {
        font-size: 14px !important;
      }
    }
  }
}

  .title-box {
    color: #ffffff;
    font-size: 14px;
    margin-top: 12px;

    .btn-box{
      width: 200px;
      height: 43px;
      border-radius: 8px;
      /* 自动布局 */
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: 4px 0;
      cursor: pointer;
      font-weight: 600;
      &.btn-box-empty {
        color: var(--color-primary);
        background: transparent;
        border: 2px solid rgba(42, 84, 209, 0.2);
      }
      &.btn-box-solid {
        background: var(--color-primary);
        box-shadow: var(--gradient-BoxShadow);
      }

      &> img,
      &>.el-icon{
        margin-right: 8px;
      }
      &>.el-icon{
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .chat-list {
    display: flex;
    flex-flow: column;
    // background-color: #28292A;
    // border-top: 1px solid #2F3032;
    // border-right: 1px solid #2F3032;
    overflow-y: scroll;
    margin-top: 14px;
    .chat-time {
      line-height: 24px;
    }

    .search-box {
      flex-wrap: wrap;
      padding: 10px 15px;
      //background-color #343540;

      .el-input__wrapper {
        background-color: #363535;
        box-shadow: none;
      }
    }

    .content {
      //display flex
      //flex-wrap: wrap;
      //flex-direction column
      width: 100%;
      // overflow-y: scroll;

      .chat-list-item,
      .chat-list-item2{
        // display: flex;
        width: 100%;
        // justify-content: flex-start;
        // align-items: center;
        padding: 0 10px;
        //border-bottom: 1px solid #3c3c3c;
        cursor: pointer;
        color: #333;

        &:hover {
          // background-color: #343540;
          background-color: var(--menu-hoverBg);
          border-radius: 8px;
        }

        // .avatar {
        //   width: 28px;
        //   height: 28px;
        //   border-radius: 50%;
        // }
        .avatar-icon{
          font-size: 16px;
          // color: #fff;
        }
        .avatar-img{
          width: 16px;
          height: 16px;
        }

        .chat-title {
          // color: #c1c1c1;
          // padding: 5px 10px;
          padding-left: 5px;
          // max-width: 220px;
          // max-width: 150px;
          font-size: 14px;
          font-weight: 500;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .chat-tag{
          border: 1px solid var(--color-primary);
          color: var(--color-primary);
          line-height: 20px;
          border-radius: 8px;
          padding: 0 4px;
          font-size: 12px;
          margin-left: 5px;
        }
        
        .chat-num {
          right: 0;
          top: -3px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #E93037;
          color: #fff;
          font-size: 12px;
          margin-left: 5px;
          transform: scale(0.75);
        }

        .btn {
          width: 32px;
          display: none;
          // position: absolute;
          // right: 2px;
          // top: 16px;
          color: #ffffff;
          font-size: 14px;
          margin-left: 5px;

          // .el-icon {
          //   margin-right: 8px;
          // }
        }
      }
      .chat-list-item {
        height: 35px;

        .chat-title-input {
          font-size: 14px;
          // margin-top: 4px;
          margin-left: 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          // width: 190px;
          width: 150px;
        }
      }
      .chat-list-item2 {
        height: 68px;
        color: #000;
        .chat-title {
          padding-left: 0;
        }
        .msg-btns {
          margin-top: 6px;
          .fist-msg {
            font-size: 12px;
            color: #666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .chat-list-item.active,
      .chat-list-item2.active {
        // background-color: #343540;
        background-color: var(--menu-hoverBg);
        border-radius: 8px;
        .btn {
          display: flex;
        }
      }
      .chat-list-item.active{
        .el-icon,
        .chat-title {
          // color: #fff135;
          color: var(--color-primary);
          font-weight: bold;
        }
        .active-none {
          display: none;
        }
      }
      .chat-list-item2.active{
        .btn{
          .el-icon {
            color: var(--color-primary);
            font-weight: bold;
          }
        }
      }
    }
  }
</style>